"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = exports.alignments = exports.overflowTypes = exports.textVariants = exports.textTypes = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

/**
 * @enum {string}
 * @alias Text.textTypes
 * @desc Enum for the different types of Text
 */
var textTypes = {
  /** page-title */
  PAGETITLE: "page-title",

  /** section-title */
  SECTIONTITLE: "section-title",

  /** item-title */
  ITEMTITLE: "item-title",

  /** parent-label */
  PARENTLABEL: "parent-label",

  /** body */
  BODY: "body",

  /** label */
  LABEL: "label",

  /** normal-case-label */
  NORMALCASELABEL: "normal-case-label",

  /** note */
  NOTE: "note",

  /** no-value */
  NOVALUE: "no-value",

  /** page-subtitle */
  PAGESUBTITLE: "page-subtitle",

  /** placeholder */
  PLACEHOLDER: "placeholder",

  /** primary */
  PRIMARY: "primary",

  /** value */
  VALUE: "value",

  /** error */
  ERROR: "error",

  /** success */
  SUCCESS: "success",

  /** warning */
  WARNING: "warning"
};
/**
 * @enum {string}
 * @alias Text.textVariants
 * @desc Enum for the different types that can be overlaid on another type
 */

exports.textTypes = textTypes;
var textVariants = {
  /** success */
  SUCCESS: "success",

  /** error */
  ERROR: "error",

  /** warning */
  WARNING: "warning"
};
/**
 * @enum {string}
 * @alias Text.overflowTypes
 */

exports.textVariants = textVariants;
var overflowTypes = {
  NOWRAP: "no-wrap",

  /** wrap */
  WRAP: "wrap",

  /** ellipsis */
  ELLIPSIS: "ellipsis"
};
/**
 * @enum {string}
 * @alias Text.alignments
 */

exports.overflowTypes = overflowTypes;
var alignments = {
  /** left */
  LEFT: "left",

  /** center */
  CENTER: "center",

  /** right */
  RIGHT: "right"
};
/**
 * @enum {string}
 * @alias Text.weights
 */

exports.alignments = alignments;
var weights = {
  /** normal */
  NORMAL: "normal",

  /** bold */
  BOLD: "bold",

  /** bold on hover */
  BOLD_ON_HOVER: "hover"
};
/**
* @class Text
* @desc A block of text
*
* @param {Text.alignments} [align=left]
*     Displays inline when true
* @param {string} [className]
*     Class name(s) to add to the top-level container/div
* @param {string} [data-id=text-block]
*     The data-id of the component
* @param {boolean} [inline=false]
*     Displays inline when true
* @param {Text.overflowTypes} [overflow]
*     Way of showing overflowed text
* @param {Text.textTypes} [type]
*     Style of text
* @param {Text.textVariants} [variant]
*     Additional styles to add
* @param {Text.weights} [weight]
*     Font weight of text
*/

var Text = function Text(_ref) {
  var _classnames;

  var align = _ref.align,
      children = _ref.children,
      className = _ref.className,
      dataId = _ref["data-id"],
      disabled = _ref.disabled,
      inline = _ref.inline,
      type = _ref.type,
      overflow = _ref.overflow,
      variant = _ref.variant,
      weight = _ref.weight;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)("text-component", className, "text-".concat(type), "text-component--overflow-".concat(overflow), (_classnames = {}, (0, _defineProperty2.default)(_classnames, "text-".concat(variant), variant), (0, _defineProperty2.default)(_classnames, "text-component--inline", inline), (0, _defineProperty2.default)(_classnames, "text-component--center", align === alignments.CENTER), (0, _defineProperty2.default)(_classnames, "text-component--left", align === alignments.LEFT), (0, _defineProperty2.default)(_classnames, "text-component--right", align === alignments.RIGHT), (0, _defineProperty2.default)(_classnames, "text-component--overflow-wrap", overflow === overflowTypes.WRAP), (0, _defineProperty2.default)(_classnames, "text-component--disabled", disabled), (0, _defineProperty2.default)(_classnames, "text-weight--normal", weight === weights.NORMAL), (0, _defineProperty2.default)(_classnames, "text-weight--bold", weight === weights.BOLD), (0, _defineProperty2.default)(_classnames, "text-weight--hover", weight === weights.BOLD_ON_HOVER), _classnames)),
    "data-id": dataId
  }, children);
};

Text.propTypes = {
  align: _propTypes.default.oneOf((0, _values.default)(alignments)),
  className: _propTypes.default.string,
  "data-id": _propTypes.default.string,
  disabled: _propTypes.default.bool,
  overflow: _propTypes.default.oneOf((0, _values.default)(overflowTypes)),
  type: _propTypes.default.oneOf((0, _values.default)(textTypes)),
  variant: _propTypes.default.oneOf((0, _values.default)(textVariants)),
  weight: _propTypes.default.oneOf((0, _values.default)(weights))
};
Text.defaultProps = {
  align: alignments.LEFT,
  "data-id": "styled-text",
  disabled: false,
  overflow: overflowTypes.WRAP,
  type: textTypes.BODY
};
Text.textTypes = textTypes;
Text.textVariants = textVariants;
Text.overflowTypes = overflowTypes;
Text.alignments = alignments;
Text.weights = weights;
var _default = Text;
exports.default = _default;